define('SuiteDynamics.CriteoCustomDataLayerFields',
	[
		'SuiteDynamics.CriteoCustomDataLayerFields.EventProcessor',
		'SuiteDynamics.CriteoCustomDataLayerFields.CustomerInformation',
		'SuiteDynamics.CriteoCustomDataLayerFields.CheckoutInformation'
	],
	function (
		EventProcessor
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp(container) {
			EventProcessor.mountToApp(container);
		}
	};
});
